export enum EnvURL {
  Configurations = `/web/configurations`,
}
